'use client';

import { Checkbox as HeroCheckbox, Label, Description } from '@heroui/react';
import { ReactNode } from 'react';

export interface CheckboxProps {
  label?: ReactNode;
  description?: ReactNode;
  isSelected?: boolean;
  defaultSelected?: boolean;
  onChange?: (isSelected: boolean) => void;
  isDisabled?: boolean;
  isInvalid?: boolean;
  variant?: 'primary' | 'secondary';
  name?: string;
  value?: string;
}

export const Checkbox = ({
  label,
  description,
  isSelected,
  defaultSelected,
  onChange,
  isDisabled,
  isInvalid,
  variant = 'primary',
  name,
  value,
}: CheckboxProps) => {
  return (
    <HeroCheckbox
      isSelected={isSelected}
      defaultSelected={defaultSelected}
      onChange={onChange}
      isDisabled={isDisabled}
      isInvalid={isInvalid}
      variant={variant}
      name={name}
      value={value}
    >
      <HeroCheckbox.Control>
        <HeroCheckbox.Indicator />
      </HeroCheckbox.Control>
      <HeroCheckbox.Content>
        {label && <Label>{label}</Label>}
        {description && <Description>{description}</Description>}
      </HeroCheckbox.Content>
    </HeroCheckbox>
  );
};
